import { X } from 'lucide-react';
import RegisterForm from './RegisterForm';
import LoginForm from './LoginForm';

const AuthModal = ({ mode, initialRole = 'parent', onClose, switchMode, onSuccess }) => {
  const handleContentClick = (e) => e.stopPropagation();
  
  const handleRegistrationSuccess = () => {
    // Close modal and let parent component handle navigation
    if (onSuccess) {
      onSuccess();
    } else {
      onClose();
    }
  };

  const handleLoginSuccess = () => {
    // Close modal and let parent component handle navigation
    if (onSuccess) {
      onSuccess();
    } else {
      onClose();
    }
  };

  const handleRequire2FA = (email) => {
    // TODO: Show 2FA modal (will be implemented in task 9)
    console.log('2FA required for:', email);
  };

  return (
    <div 
      className="fixed inset-0 z-[60] flex items-center justify-center bg-[#17386E]/40 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden modal-animate"
        onClick={handleContentClick}
      >
        <div className="bg-[#EAF4FB] p-8 pb-6">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="font-playfair font-bold text-2xl text-[#17386E] mb-2">
                {mode === 'signup' ? 'Créer votre compte' : 'Bon retour parmi nous'}
              </h2>
              <p className="font-montserrat text-sm text-gray-500">
                {mode === 'signup' ? 'Rejoignez la communauté MyEduCycle' : 'Accédez à votre espace de suivi'}
              </p>
            </div>
            <button onClick={onClose} className="text-[#17386E] hover:bg-[#17386E]/10 rounded-full p-2 transition-colors">
              <X size={24} />
            </button>
          </div>

        </div>

        <div className="p-8 pt-6">
          {mode === 'signup' ? (
            <RegisterForm onSuccess={handleRegistrationSuccess} initialRole={initialRole} />
          ) : (
            <LoginForm 
              onSuccess={handleLoginSuccess} 
              onRequire2FA={handleRequire2FA}
            />
          )}

          <div className="mt-6 text-center">
            <p className="text-sm font-montserrat text-gray-500">
              {mode === 'signup' ? 'Déjà inscrit ?' : 'Pas encore de compte ?'}
              <button 
                onClick={() => switchMode(mode === 'signup' ? 'login' : 'signup')}
                className="ml-2 font-bold text-[#17386E] hover:text-[#4CE0C2] transition-colors underline decoration-2 underline-offset-4"
              >
                {mode === 'signup' ? 'Se connecter' : "S'inscrire"}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
